import React, { useEffect, useState } from "react";
import { Backdrop } from "@mui/material";
import "./Loader.css";
const BackDropComponent = (props) => {
    const [snackbarOpen, setBackDropOpen] = useState(props.open);
    useEffect(() => {
        setBackDropOpen(props.open);
    }, [props.open]);
    return (React.createElement(Backdrop, { sx: { color: "#fff", zIndex: "9999999" }, open: snackbarOpen },
        React.createElement("span", { className: "loader" })));
};
export default BackDropComponent;
